import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { getCatharsis, getInvalidationHandler, MegaStore } from '@wix/thunderbolt-catharsis'
import { stringifyAllComponentsCss, getComponentsCss, componentNodes } from '@wix/thunderbolt-catharsis-extensions'
import { defaultSchemas as schemas } from './defaultSchemas'

const RELEVANT_DATA_MAPS = ['layout_data', 'variants_data', 'variables'] as const

export const getCatharsisCss = (beckyModel: BeckyModel): MegaStore => {
	const { structure, data, renderFlags, experiments } = beckyModel

	const catharsisMegaStore = new MegaStore()
	const onInvalidation = getInvalidationHandler(catharsisMegaStore)

	const catharsis = getCatharsis({ onInvalidation, extensions: { componentNodes, schemas } })
	catharsis.transaction(({ updateStructure, updateData, updateEnvironment }) => {
		updateEnvironment({ renderFlags, experiments })
		for (const compId in structure) {
			updateStructure(compId, structure[compId])
		}
		for (const dataMapName of RELEVANT_DATA_MAPS) {
			for (const id in data[dataMapName]) {
				const dataItem = data[dataMapName][id]
				updateData(dataMapName, id, dataItem)
			}
		}
	})

	return catharsisMegaStore
}

export const getCatharsisCssString = (beckyModel: BeckyModel): string => {
	const catharsisMegaStore = getCatharsisCss(beckyModel)
	return stringifyAllComponentsCss(
		getComponentsCss(catharsisMegaStore, beckyModel.structure, beckyModel.pageCompId, beckyModel.experiments)
	)
}
